import styled from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';
import { TypeEyebrow, TypeCaption } from 'components/library/Typography';

export const FooterNavWrapper = styled.nav`
  grid-column: 1 / -1;

  @media ${mqLargeMin} {
    grid-column: 8 / span 5;
    margin-top: 0;
  }
`;

export const FooterGridList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  row-gap: var(--spacing-24);
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const FooterHeading = styled.li`
  flex-grow: 1;
  width: 50%;

  span {
    opacity: 0.5;
  }

  @media ${mqLargeMin} {
    width: 33%;
  }
`;

export const FooterList = styled.ul`
  margin-inline: 0;
  margin-block-start: var(--spacing-16);
  padding: 0;
  list-style: none;

  li + li {
    /* start-only: a block-end margin here escapes the list box and pushes
       the country selector below its 32px design gap */
    margin-block-start: var(--spacing-8);
  }
`;

export const FooterLink = styled(TypeCaption)`
  color: var(--fill-primary);
  text-decoration: none;
  font-size: var(--font-size-350);

  &:hover {
    color: var(--fill-primary);
    opacity: 0.5;
  }
`;

export const FooterEyebrow = styled(TypeEyebrow)`
  color: var(--fill-primary);
  opacity: 0.5;
`;
